import { Component } from '@angular/core';

@Component({
  selector: 'app-password-changed-success-dialog',
  templateUrl: './password-changed-success-dialog.component.html',
  styleUrl: './password-changed-success-dialog.component.scss'
})
export class PasswordChangedSuccessDialogComponent {

}
